import { render, staticRenderFns } from "./MoreInfo.vue?vue&type=template&id=14d1ac31&scoped=true&"
import script from "./MoreInfo.ts?vue&type=script&lang=ts&"
export * from "./MoreInfo.ts?vue&type=script&lang=ts&"
import style0 from "./MoreInfo.scss?vue&type=style&index=0&id=14d1ac31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d1ac31",
  null
  
)

export default component.exports